import React from 'react'

import './About.css'


const About = () => {
  return (
    <div className="about-me">
        <div className="about-main-header">About Me</div>
        <div className="about-heading">What I do</div>
        I started my professional journey by pursuing a MS in Computer Science at DePaul, having recently decided that law school was not the next step in my path.
        I graduated in 2018, while working at a Chicago-based EdTech startup. By this time,
        I had picked up skills in Python and Java, as well as valuable lessons on how to be a successful engineer.
        I eventually entered the world of consulting, and gained further experience as a technical lead and solutions architect.
        I earned my Professional Cloud Architect certification from Google and my Solutions Architect Associate certification from Amazon,
        and very much enjoy both working with clients to architect solutions as well as collaborating with and mentoring teammates.
        I have also attended and hosted various tech meetups in the Chicago area,
        where I have presented on tech topics as well as mentored newer programmers on best practices.

        <br/>
        Outside of tech, I organize social meetups. I've partnered with bars to host events, bringing in as many as 90 people for singles mixers, karaoke,
        and after-work drinks, as well as farmers market picnics and outdoor festival trips.

        <img className="about-image" src="/working.jpg"/>

        <br/>
        <div className="about-heading">What I know</div>
        <ul style={{"listStyleType": "none"}}>
          <li>Programming languages: Python 3, Kotlin, Java 11+, JavaScript/TypeScript</li>
          <li>Cloud technologies: Amazon Web Services (AWS), Google Cloud Platform (GCP), Cloud Foundry</li>
          <li>Frameworks: Spring Boot, Django, Flask/Chalice, Angular, React.js</li>
          <li>Languages: English (native/fluent), Spanish (intermediate)</li>
          <li>Other skills: Event organizing and hosting, mentorship, Agile software development</li>
        </ul>

        <br/>
        This website is designed in React.js and is hosted in S3.

        <img className="about-image" src="/bar.jpg"/>

        <br/>
        <div className="about-heading">Who I am</div>
        In my free time, I enjoy Muay Thai, MMA, running, playing the violin and guitar, learning languages, travel, and keeping up with current events.
        I'm a big brother to one, a son to two, a friend to many, and a pain in the neck to my therapist. 
    </div>
  )
}

export default About;
